import { AxiosRequestConfig } from "axios";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";

export const jsonHeader = (
  method: string,
  endpoint: string,
  body?: string
): AxiosRequestConfig => {
  let Authorization: string;

  try {
    Authorization =
      AuthenticationHelper.getAuthHeader(method, endpoint, body) || "";
  } catch (error) {
    // Create a properly typed context object with error details and request info
    const errorContext: Record<string, unknown> = {
      requestInfo: {
        method,
        endpoint,
        bodyLength: body ? body.length : 0,
      },
    };

    // Only add error details if error is defined
    if (error !== undefined) {
      errorContext.error =
        error instanceof Error
          ? {
              message: error.message,
              stack: error.stack,
              name: error.name,
            }
          : String(error);
    }

    DatadogLogger.Log(
      `CreditLine Error - Auth Header error`,
      errorContext,
      LogType.ERROR
    );
    Authorization = "";
  }

  return {
    headers: {
      "Content-Type": "application/json",
      // eslint-disable-next-line
      Authorization,
    },
  };
};
